import Button from '../Button/Button.js';
import cx from 'classnames';
import ReactModal from 'react-modal';
import SvgRedirectIllustration from './assets/redirect-illustration.svg.js';
import styles from './RedirectModal.module.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const RedirectModal = ({
  isOpen,
  redirectUrl,
  isMobile,
  onClickPrimaryCta,
  onRequestClose,
  appElement = "#__next",
  onClickSecondaryCta,
  appStoreUrl
}) => {
  const modalClass = cx(styles.modal, styles.defaultDimensions, isMobile ? styles.mobileMod : styles.mod);
  if (process.env.NODE_ENV === "test") {
    ReactModal.setAppElement("div");
  } else {
    ReactModal.setAppElement(appElement);
  }
  return /* @__PURE__ */ jsx(ReactModal, {
    isOpen,
    onRequestClose,
    overlayClassName: styles.overlay,
    className: modalClass,
    "aria-labelledby": "dialog-title",
    "aria-describedby": "dialog-desc",
    children: /* @__PURE__ */ jsxs("div", {
      className: styles.content,
      "data-test-id": "redirect-modal",
      children: [/* @__PURE__ */ jsx("div", {
        className: styles.illustration,
        children: /* @__PURE__ */ jsx(SvgRedirectIllustration, {
          style: {
            width: 215,
            height: 137
          }
        })
      }), /* @__PURE__ */ jsx("div", {
        className: styles.titleText,
        id: "dialog-title",
        children: /* @__PURE__ */ jsx("span", {
          children: "Ready to place a bet?"
        })
      }), /* @__PURE__ */ jsx("p", {
        className: styles.subText,
        id: "dialog-desc",
        children: isMobile ? "To start placing bets, you'll need to download the app." : "To place a bet, you'll need to log in."
      }), /* @__PURE__ */ jsxs("div", {
        className: styles.buttonsContainer,
        children: [/* @__PURE__ */ jsx("a", {
          href: isMobile ? appStoreUrl : redirectUrl,
          target: isMobile ? "_blank" : void 0,
          rel: isMobile ? "noopener noreferrer" : void 0,
          children: /* @__PURE__ */ jsx(Button, {
            className: styles.button,
            buttonColor: "Green",
            testId: "primary-cta",
            buttonText: isMobile ? "Download Sportsbook app" : "Go to betslip",
            onClick: onClickPrimaryCta
          })
        }), isMobile && /* @__PURE__ */ jsx("a", {
          href: redirectUrl,
          children: /* @__PURE__ */ jsx(Button, {
            className: styles.button,
            testId: "secondary-cta",
            buttonText: "Open Sportsbook app",
            onClick: onClickSecondaryCta
          })
        }), /* @__PURE__ */ jsx(Button, {
          buttonStyle: "Naked",
          className: styles.button,
          onClick: onRequestClose,
          buttonText: "Never mind",
          testId: "close-button"
        })]
      })]
    })
  });
};

export { RedirectModal as default };
//# sourceMappingURL=RedirectModal.js.map
